import { useEffect, useState } from "react";

export const InternetConnectionAlertHeader = () => {
    const [isOnline, setIsOnline] = useState(navigator.onLine);
  
    useEffect(() => {
      const handleOnline = () => setIsOnline(true);
      const handleOffline = () => setIsOnline(false);
  
      window.addEventListener("online", handleOnline);
      window.addEventListener("offline", handleOffline);
  
      // Limpa os event listeners quando o componente desmonta
      return () => {
        window.removeEventListener("online", handleOnline);
        window.removeEventListener("offline", handleOffline);
      };
    }, []);
  
    return (
  
        !isOnline && (
          <div
          className="mb-20 px-2 py-1 rounded bg-red-600 text-center text-white text-[10px]">
            Sem conexão com a internet! Veifique sua rede
          </div>
        )
  
    );
  };